import intlTelInput from 'intl-tel-input';
import consumer from "../channels/consumer"
import SocketHandler from "./utils/SocketHandler"
import NavigationHistoryHandler from "./utils/NavigationHistoryHandler"

import PremiumModal from "../common/PremiumModal";

import UserLive from "./controllers/UserLive.js"
import TrackUpload from "./controllers/TrackUpload"
import LiveWorldMap from "./controllers/LiveWorldMap.js"
import UserShow from "./controllers/UserShow.js"
import TrackShow from "./controllers/TrackShow.js"
import TrackShowMap from "./controllers/TrackShowMap.js"
import 'intl-tel-input/build/css/intlTelInput.css';
import SceneNew from "./controllers/SceneNew.js"
import SceneShow from "./controllers/SceneShow.js"
import "flag-icon-css/css/flag-icon.css"
import "@mdi/font/css/materialdesignicons.css"
import SearchBar from "./utils/SearchBar";
import LocalitiesIndex from "./controllers/LocalitiesIndex";
import HomeIndex from "./controllers/HomeIndex";
import '../../assets/images/website/home_banner.png';
import '../../assets/images/website/badge.png';
import CookiesIndex from "./controllers/CookiesIndex";
import UserFollow from "./controllers/UserFollow";
import ConfigurationIndex from "./controllers/ConfigurationIndex";
import CheckoutIndex from "./controllers/CheckoutIndex";
import ToastNotification from "./utils/ToastNotification";
import InvoiceShow from "./controllers/InvoiceShow";
import DeviseUser from "./controllers/DeviseUser";
import SearchIndex from "./controllers/SearchIndex";
import LazyLoad from "./utils/LazyLoad";
import CheckoutPaymentOk from "./controllers/CheckoutPaymentOk";
import Favico from 'favico.js';
import UserStats from "./controllers/UserStats";
import ApexCharts from 'apexcharts';
import CheckoutFastStripe from './controllers/CheckoutFastStripe';
window.ApexCharts = ApexCharts;
window.intlTelInput = intlTelInput;

$ = window.$;

const NOTIFY_CHANNEL_NAME = "NotificationChannel";
const GARMIN_INTEGRATION_NOTIFY_KEY = 19;
const SUUNTO_INTEGRATION_NOTIFY_KEY = 20;

export default class Application {
	constructor() {
		this.update_notifications_ids = [];
		this.fitty = require("fitty/dist/fitty.min");
		this.fitties = null;
		this.controller_name = null;
		this.action_name = null;

		this.current_handler = null;
		this.trackuploadHandler = null;
    	this.navigationHistoryHandler = new NavigationHistoryHandler();
		this.searchBarHandler = null;
		this._dataChangedListener = null;
		this.favicon = null;

		this.deferredPrompt = null;
		// this.consumer = consumer;

		this.socket_handler = new SocketHandler(consumer);
		this.mobileAndTabletCheck = function() {
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		};
		this.premiumModal = new PremiumModal();

		this.bindEvents();
		this.init_third_parties();

		this.socket_handler.subscribe({ channel: NOTIFY_CHANNEL_NAME, token: cookies.get("STL-Token") });
		this.socket_handler.off(NOTIFY_CHANNEL_NAME);
		this.socket_handler.on(NOTIFY_CHANNEL_NAME, (e, data) => {
			this.onNewNotification(data);
        });
    }

    bindEvents() {
		$(document).off("turbolinks:visit").on('turbolinks:visit', (e) => {
				$(document).off("Application::PageChanged");
			if (this.current_handler?.onDestroy) {
				this.current_handler.onDestroy();
				}
			});
    }

    setController(controller) {
      this.controller_name = controller;
    }

    setAction(action) {
      this.action_name = action;
    }

    setData(data) {
      this.data = data;
		this._dataChangedListener != null &&
        this._dataChangedListener.onDataChanged(data);
      }

	setOnDataChangeListener(listener) {
		this._dataChangedListener = listener;
	}

    getAPIUrl() {
      return $("meta[name=api-url]").attr("content");
    }

    getPremiumUrl() {
      return $("meta[name=premium-url]").attr("content");
    }

    getTrackUploadLimit() {
      return parseInt($("meta[name=track_upload_limit_no_premium]").attr("content"));
    }

    isPremium() {
      return $("meta[name=is-premium]").attr("content") === "true"
    }

    getMeta(name){
		return $("meta[name="+name+"]").attr("content");
	}

    pageChanged() {
		this.current_handler = null;
		this._dataChangedListener = null;
    	
    	this.searchBarHandler = new SearchBar();

		if(this.controller_name==="track") {
			if(this.action_name==="show_map") {
				this.current_handler = new TrackShowMap();
			}
			else if(this.action_name==="show") {
				this.current_handler = new TrackShow();
			}else if(this.action_name==="new") {
                this.trackuploadHandler = new TrackUpload();
            }
		}
		else if(this.controller_name==="live") {
			if(this.action_name==="index") {
				this.current_handler = new LiveWorldMap();
			}
		  	else if(this.action_name==="show") {
				this.current_handler = new UserLive();
			}
		}
		else if(this.controller_name==="scene") {
		  if(this.action_name==="new") {
			this.current_handler = new SceneNew();
		  }
		  else if(this.action_name==="show") {
			this.current_handler = new SceneShow();
		  }
		}
		else if(this.controller_name==="user") {
			if(this.action_name==="show") {
				this.current_handler = new UserShow();
			}else if(this.action_name==="follow"){
				this.current_handler = new UserFollow();
			}else if(this.action_name==="stats" || this.action_name==="better_stats"){
				this.current_handler = new UserStats();
			}
		}
		else if(this.controller_name==="localities") {
			if(this.action_name==="index") {
				this.current_handler = new LocalitiesIndex();
			}
		}
		else if(this.controller_name==="home") {
			if(this.action_name==="index") {
				this.current_handler = new HomeIndex();
			}
		}
		else if(this.controller_name==="cookies") {
			if(this.action_name==="index") {
				this.current_handler = new CookiesIndex();
			}
		}
		else if(this.controller_name==="configuration") {
			if(this.action_name==="index") {
				this.current_handler = new ConfigurationIndex();
			}
		}
		else if(this.controller_name==="checkout") {
			if(this.action_name==="index") {
				this.current_handler = new CheckoutIndex();
			}
			if(this.action_name==="payment_ok") {
				this.current_handler = new CheckoutPaymentOk();
			}
			if(this.action_name==="fast_stripe") {
				this.current_handler = new CheckoutFastStripe();
			}
		}
		else if(this.controller_name==="invoice") {
			if(this.action_name==="show") {
				this.current_handler = new InvoiceShow();
			}
		}
		else if(this.controller_name==="registrations") {
			if(this.action_name==="new") {
				this.current_handler = new DeviseUser();
			}
		}
		else if(this.controller_name==="search") {
			if(this.action_name==="index") {
				this.current_handler = new SearchIndex();
			}
		}
		else if(this.controller_name==="passwords") {
			if(this.action_name==="new") {
				this.current_handler = new DeviseUser(true);
			}
			if(this.action_name==="edit") {
				this.current_handler = new DeviseUser();
			}
		}

      	//$(document).trigger("Application::PageChanged", {});
      	this.setData(window.data);

		this.setFaviconNotifications();

		this.navigationHistoryHandler.pageChanged();
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (!["live", "scene", "track"].includes(this.controller_name) ||
			!["show", "show_map"].includes(this.action_name)
		) {
			//!urlParams.has('stlContext') && this.set_rgpd();
			}

    if(window.notice_text !== undefined){
    	ToastNotification.make(window.notice_text);
		window.notice_text = undefined;
	}
    if(window.alert_text !== undefined){
    	ToastNotification.make(window.alert_text);
		window.alert_text = undefined;
	}

    this.bindEventsAfterPageChanged();
  }

	set_rgpd() {
		if (!cookies.get("gdpr")) {
			$(document.body).append(this.rgpd_banner())
		}
		$(".accept_c").off("click").on("click", (e) => {
			e.preventDefault();
			cookies.create("gdpr","tracking,third_party", 365*5)
			$("#cookie_consent").hide();
			//document.location.reload(true);
		})
		$(".decline_cookies").off("click").on("click", (e) => {
			e.preventDefault();
			cookies.create("gdpr",[],365*5)
			$("#cookie_consent").hide();
		})
	}

	rgpd_banner() {
		return '<div id="cookie_consent" class="fixed-bottom border-top border-light-gray py-3" style="background-color: #aaff00;">\n' +
			'    <div>\n' +
			'      <div class="row justify-content-center">\n' +
			'        <div class="col-12 fs-13 px-lg-5">\n' +
			'          <div class="pl-2 pr-2">\n' +
			'            '+I18n.t("website.rgpd_banner.content") +
			'            .<a href="/cookies" target="_blank" class="link-color">\n' +
			'            '+I18n.t("website.rgpd_banner.more_info")+'\n' +
			'            </a>\n' +
			'          </div>\n' +
			'        </div>\n' +
			'        <div class="col-4 text-center">\n' +
			'          <a href="" class="accept_c btn btn-secondary py-2 mt-2">\n' +
			'            '+I18n.t("website.rgpd_banner.accept")+'\n' +
			'          </a><br />\n' +
			'          <a href="" class="decline_cookies w-100 fs-11">\n' +
			'            '+I18n.t("website.rgpd_banner.reject")+'\n' +
			'          </a>\n' +
			'        </div>\n' +
			'      </div>\n' +
			'    </div>\n' +
			'  </div>';
	}

	init_third_parties() {
		if (!cookies.get("gdpr")?.includes("third_party")) {
			$(".accept_c").off("click").on("click", (e) => {
				e.preventDefault();
				cookies.create("gdpr","tracking,third_party", 365*4)
				$("#cookie_consent").hide();
				//document.location.reload(true);
			});
		}
	}

	bindEventsAfterPageChanged() {
		const self = this;

		$(".show-premium-modal").off("click").on("click", function(e){
			e.preventDefault();
			self.premiumModal.showModal();
		});	

        $("#close_premium_modal").off("click").on("click", function(e){
			e.preventDefault();
			self.premiumModal.closeModal();
		});	

		$(".js-lang").off("click").on("click", function (e) {
			e.preventDefault();
			$('.dropdown-selector-lang').text($(this).data('text'));
			cookies.create('new_lang', $(this).data('code'));
			document.location.reload();
		})

		this.reloadFitty();
		this.reloadLazyLoad();

		$('.dropdown-menu.keep-open').unbind("click").on('click', function (e) {
			e.stopPropagation();
		});

		this.setNotificationHandlers();
	}

	setNotificationHandlers() {
		const self = this;
		if(this.mobileAndTabletCheck()){
			$("#notifyDropdown").off("click").on("click", function (e) {
				$('.notification_element[data-opened=false]').each(function () {
					if(!self.update_notifications_ids.includes($(this).data("id"))){
						let notification_id = $(this).data("id");
						self.update_notifications_ids.push(parseInt(notification_id));
						let ajaxData = {
							url: window.application.getAPIUrl()+"/v1/notification/opened",
							data: {notification_id: notification_id},
							method: "PUT",
							beforeSend: function(request) {
								request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
							},
						};
						$.ajax(ajaxData).done(function(data) {
							if (data !== undefined){
								$('.notification_element[data-id='+data.notification_id+']').data("opened",true)
								setTimeout(() => {
									$("#notification_dot_"+data.notification_id).fadeOut({duration: 200})
									self.descendNotificationsCount();
								}, 1000);
								self.update_notifications_ids.splice(self.update_notifications_ids.indexOf(parseInt(data.notification_id)), 1);
							}
						});
					}
				});
			});
		}else{
			$(".notification_element").off("mouseenter").on("mouseenter", function (e) {
				if($(this).data("opened") === false && !self.update_notifications_ids.includes($(this).data("id")) ){
					self.openNotification(this);
				}
			});
			$(".js-delete_all_notifications").off("click").on("click", (e) => {
				e.preventDefault();
				this.openAllNotification();
			});
		}
	}

	setFaviconNotifications(count = null) {
		if (count !== null) {
			$("body").data("notifications-count", count);
	}
		this.favicon = new Favico({ animation: 'none' });
		this.updateNotificationsCount();
	}

	descendNotificationsCount(){
		const value = parseInt($("body").data("notifications-count"))
		$("body").data("notifications-count", value > 0 ? value - 1 : 0);
		this.updateNotificationsCount();
	}

	increaseNotificationsCount() {
		$("body").data("notifications-count", parseInt($("body").data("notifications-count")) + 1);
		this.updateNotificationsCount();
	}

	updateNotificationsCount() {
		const count = parseInt($("body").data("notifications-count") ?? 0);
		this.favicon.badge(count);
		$(".js-notification-count").each(function () {
			$(this).data("count", count);
			$(this).text(count);
			$(this).css({ visibility: count > 0 ? 'visible' : 'hidden' });
		});
			}

	resetNotificationsCount(){
		$("body").data("notifications-count", 0);
		this.favicon && this.favicon.badge(0);
		$(".js-notification-count").each(function () {
			$(this).remove();
		});
	}

	onNewNotification(data) {
		const ajaxData = {
			url: this.getAPIUrl() + "/v1/notification",
			data: { id: data.notification },
			method: "GET",
			beforeSend: (request) => {
				request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
			},
		};
		$.ajax(ajaxData).done((notification) => {
			$('.notification-dropdown .scrollbar').prepend(notification);
			this.increaseNotificationsCount();
			this.setNotificationHandlers();
			
			if (data.what === GARMIN_INTEGRATION_NOTIFY_KEY) {
				ToastNotification.make(I18n.t("website.notifications.garmin_integration_successfull.subject"));
			}

			if (data.what === SUUNTO_INTEGRATION_NOTIFY_KEY) {
				ToastNotification.make(I18n.t("website.notifications.suunto_integration_successfull.subject"));
			}
		});
	}

	openNotification(item){
		const notification_id = $(item).data("id");
		this.update_notifications_ids.push(parseInt(notification_id));
		const ajaxData = {
			url: this.getAPIUrl()+"/v1/notification/opened",
			data: {notification_id: notification_id},
			method: "PUT",
			beforeSend: (request) => {
				request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
			},
		};
		$.ajax(ajaxData).done((data) => {
			if (data !== undefined){
				$('.notification_element[data-id='+data.notification_id+']').data("opened",true)
				$(".notification_dot[data-id="+data.notification_id+"]").fadeOut({duration: 200})
				this.update_notifications_ids.splice(this.update_notifications_ids.indexOf(parseInt(data.notification_id)), 1);
				this.descendNotificationsCount();
			}
		});
	}

	openAllNotification(){
		const ajaxData = {
			url: this.getAPIUrl()+"/v1/notification/open_all",
			data: {},
			method: "PUT",
			beforeSend: (request) => {
				request.setRequestHeader("X-STL-Token", cookies.get("STL-Token"));
			},
		};
		$.ajax(ajaxData).done((data) => {
			$('.notification_element').data("opened",true)
			$(".notification_dot").fadeOut({duration: 200})
			this.resetNotificationsCount();
		});
	}

	reloadFitty() {
		if(this.fitties !== null ){
			this.fitties.forEach(function (item) {
				item.unsubscribe();
			})
			this.fitties = null
		}
		this.fitties = window.application.fitty('.fit', {
			minSize: 5,
			maxSize: 16
		});
	}

	reloadLazyLoad() {
		LazyLoad.make();
	}

	copyToClipboard(element) {
		var copyText = document.getElementById(element);
		copyText.type = 'text';
    	ToastNotification.make("Copied");
		window.notice_text = undefined;
		copyText.select();
		document.execCommand("copy");
		copyText.type = 'hidden';
		if(element === "myToken"){
		alert("Token Copied and ready to be paste on Livetrack360 as Password:\n\n" + copyText.value + "\n\nWe will now load a new Tab for Livetrack360\n\nFrom your Devices page:\n1. Integrations\n2. Add Integration\n3. Select LT Server\n4. Select SportsTrackLive\n5. Set your Username\n6. Paste your Token in Password field\n7. Save (and Enjoy)");
		window.open('https://livetrack360.com/devices', '_blank');
}
}
}

window.application = new Application();

$(document).on('turbolinks:load', (event) => {
	const url = event.currentTarget.URL;
    let previousUrl = cookies.get("current-url") || url;
    cookies.create("previous-url",previousUrl);
    cookies.create("current-url",url);
    ToastNotification.showPostponedMessage();
	$(document).on("submit", "form[method=get]", function(e) {
	    Turbolinks.visit(this.action+(this.action.indexOf('?') == -1 ? '?' : '&')+$(this).serialize());
	    return false;
	});

	moment.locale(I18n.locale);

	Turbolinks.setProgressBarDelay(500);

	application.setController($("body").data("controller"));
	application.setAction($("body").data("action"));
	application.pageChanged();

	window.$('.js-select2').select2({
		theme: 'bootstrap4',
		templateResult: formatState,
		templateSelection: formatState,
		language: I18n.locale
	});

	$.fn.datepicker.defaults.language = I18n.locale;

	window.$('[data-toggle="tooltip"]').tlp();

	window.$('.notify_toast').toast({
		animation: true,
		autohide: true,
		delay: 10000
	});
});

function formatState (state) {
	if (!state.id) {
		return state.text;
	}
	var $state = $(
		'<span class="lh-5">\n<span class="bg-secondary dot-md mr-2 fs-20"><i class="text-white icon icon-'+$(state.element).data("icon")+'"></i></span>' + state.text + '</span>'
	);
	return $state;
};